/** Plantillas de plan comercial (FASE1 — presets ops, no catálogo global). */

export const EMPTY_PLAN_FORM = {
  arca_enabled: false,
  copilot_enabled: false,
  max_documents_monthly: "",
  fallback_tokens_model: "FLAT",
  fallback_tokens_included: "",
  monthly_base_fee_ars: "",
  currency: "ARS",
  effective_from: "",
};

export const PLAN_PRESETS = [
  {
    id: "starter",
    name: "Starter",
    description: "Sin ARCA ni Copilot · 200 docs/mes · fallback FLAT",
    arca_enabled: false,
    copilot_enabled: false,
    max_documents_monthly: 200,
    fallback_tokens_model: "FLAT",
    fallback_tokens_included: 200000,
    monthly_base_fee_ars: 150000,
  },
  {
    id: "growth",
    name: "Growth",
    description: "ARCA · 700 docs/mes · fallback FLAT",
    arca_enabled: true,
    copilot_enabled: false,
    max_documents_monthly: 700,
    fallback_tokens_model: "FLAT",
    fallback_tokens_included: 500000,
    monthly_base_fee_ars: 350000,
  },
  {
    id: "scale",
    name: "Scale",
    description: "ARCA + Copilot · 2000 docs/mes · fallback FLAT",
    arca_enabled: true,
    copilot_enabled: true,
    max_documents_monthly: 2000,
    fallback_tokens_model: "FLAT",
    fallback_tokens_included: 1000000,
    monthly_base_fee_ars: 650000,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    description: "Full · docs ilimitados · fallback PAYG",
    arca_enabled: true,
    copilot_enabled: true,
    max_documents_monthly: null,
    fallback_tokens_model: "PAY_AS_YOU_GO",
    fallback_tokens_included: null,
    monthly_base_fee_ars: 1200000,
  },
];

export function presetToForm(preset) {
  if (!preset || preset.id === "custom") return { ...EMPTY_PLAN_FORM };
  return {
    arca_enabled: !!preset.arca_enabled,
    copilot_enabled: !!preset.copilot_enabled,
    max_documents_monthly: preset.max_documents_monthly ?? "",
    fallback_tokens_model: preset.fallback_tokens_model || "FLAT",
    fallback_tokens_included: preset.fallback_tokens_included ?? "",
    monthly_base_fee_ars: preset.monthly_base_fee_ars ?? "",
    currency: "ARS",
    effective_from: new Date().toISOString().slice(0, 10),
  };
}

export function planToForm(plan) {
  if (!plan) return { ...EMPTY_PLAN_FORM };
  return {
    arca_enabled: !!plan.arca_enabled,
    copilot_enabled: !!plan.copilot_enabled,
    max_documents_monthly: plan.max_documents_monthly ?? "",
    fallback_tokens_model: plan.fallback_tokens_model || "FLAT",
    fallback_tokens_included: plan.fallback_tokens_included ?? "",
    monthly_base_fee_ars: plan.monthly_base_fee_ars ?? "",
    currency: plan.currency || "ARS",
    effective_from: plan.effective_from || "",
  };
}

export function buildPlanInput(tenantId, form) {
  return {
    tenant_id: tenantId,
    arca_enabled: form.arca_enabled,
    copilot_enabled: form.copilot_enabled,
    max_documents_monthly:
      form.max_documents_monthly === "" || form.max_documents_monthly == null
        ? null
        : Number(form.max_documents_monthly),
    fallback_tokens_model: form.fallback_tokens_model,
    fallback_tokens_included:
      form.fallback_tokens_included === "" || form.fallback_tokens_included == null
        ? null
        : Number(form.fallback_tokens_included),
    monthly_base_fee_ars:
      form.monthly_base_fee_ars === "" || form.monthly_base_fee_ars == null
        ? null
        : Number(form.monthly_base_fee_ars),
    currency: form.currency || "ARS",
    effective_from: form.effective_from || null,
  };
}

export function formatPlanSummary(form) {
  const docs =
    form.max_documents_monthly === "" || form.max_documents_monthly == null
      ? "Ilimitado"
      : `${form.max_documents_monthly} docs/mes`;
  const fallback =
    form.fallback_tokens_model === "PAY_AS_YOU_GO"
      ? "Fallback PAYG"
      : `Fallback FLAT (${Number(form.fallback_tokens_included || 0).toLocaleString("es-AR")} incl.)`;
  return [
    form.arca_enabled ? "ARCA" : "Sin ARCA",
    form.copilot_enabled ? "Copilot" : "Sin Copilot",
    docs,
    fallback,
    form.monthly_base_fee_ars
      ? `$${Number(form.monthly_base_fee_ars).toLocaleString("es-AR")}/mes`
      : null,
  ]
    .filter(Boolean)
    .join(" · ");
}
